export default __webpack_public_path__ + "static/media/feature-3.2f73d040.svg";